import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
} from '@cmps/ng-bootstrap';

import { CmpsAuthModule } from '../auth/auth.module';
import { CmpsLazyRouterModule } from '../route.module';

import { DebugPanelComponent } from './panel.debug.component';

@NgModule({
    imports: [
        CommonModule,
        NgbCollapseModule,
        NgbDropdownModule,
        NgbModalModule,
        CmpsLazyRouterModule,
        CmpsAuthModule,
    ],
    declarations: [DebugPanelComponent],
    exports: [DebugPanelComponent],
})
export class CmpsDebugModule {}
